// @flow
import React, {useState, useEffect} from "react";
import {useObserver} from "mobx-react-lite";
import {Row, Col, Select} from "antd";
import {useStore} from "../../../hooks/useStore";
import {useFetch} from "../../../hooks/useFetch";
import {CourierIcon} from "../../_defaultComponents/CourierIcon/CourierIcon";
import {formatPhoneNumber} from "../../../utils/helpers";
import {IconCol, SlotCourierSelectField} from "./optionsStyles";
import {useTranslation} from "react-i18next";

const {Option} = Select;

export const SlotCourierDedication = ({companyId, disabled, onChange, index, couriers}) => {
    const stores = useStore();
    const {t} = useTranslation(["slotCourierDedication"]);
    const [courierOptions, setCourierOptions] = useState([]);
    const [slotCourierList, setSlotCourierList] = useState([]);
    const [initCall, setInitCall] = useState(true);

    const [slotCouriersLoading, slotCouriers, setSlotCouriers, setSlotCouriersLoading] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.courierStore.getSlotCouriers.bind(null, {
            companyId
        }),
        dependencies: [],
        initialCall: true
    });

    useEffect(() => {
        setCourierOptions(
            slotCouriers.map(courier => {
                return (
                    <Option
                        data-testid="slotCourierDedication_option"
                        key={courier.fullname}
                        value={courier._id}
                    >
                        <Row>
                            <IconCol>
                                <CourierIcon courierType={courier.type} />
                            </IconCol>
                            <Col>
                                <Row>{courier.fullname}</Row>
                                <Row>{formatPhoneNumber(courier.cellPhone)}</Row>
                            </Col>
                        </Row>
                    </Option>
                );
            })
        );
    }, [slotCouriers]);

    useEffect(() => {
        if (!initCall) {
            const courierList = [];
            slotCourierList.forEach(courier => {
                const courierDetail = slotCouriers.find(c => c._id === courier);
                courierDetail &&
                    courierList.push({
                        _id: courierDetail._id,
                        fullname: courierDetail.fullname,
                        courierType: courierDetail.type
                    });
            });
            onChange({[index]: courierList});
        }
    }, [slotCourierList]);

    useEffect(() => {
        setSlotCourierList(couriers?.map(courier => courier._id));
        setInitCall(true);
    }, [couriers]);

    return useObserver(() => (
        <div style={{marginTop: "1vh"}}>
            <SlotCourierSelectField
                mode="multiple"
                disabled={disabled}
                allowClear
                style={{width: "100%"}}
                value={slotCourierList}
                placeholder={t("slotCourierDedication.fields.chooseCourier", {
                    ns: "slotCourierDedication"
                })}
                optionFilterProp="children"
                filterOption={(inputValue, option) => {
                    return option.key
                        .toLocaleLowerCase("tr")
                        .includes(inputValue.toLocaleLowerCase("tr"));
                }}
                onChange={e => (setSlotCourierList(e), setInitCall(false))}
            >
                {courierOptions}
            </SlotCourierSelectField>
        </div>
    ));
};
